import type { RefObject } from 'react';
import { BaseHeaderActions } from '@/components/shared/BaseHeaderActions';
import type { ModelConfigsInfo } from '@/api-types';

interface EditorHeaderActionsProps {
  modelConfigs?: ModelConfigsInfo;
  onRequestConfigs: () => void;
  loadingConfigs: boolean;
  onGitCloneClick: () => void;
  isGitHubExportReady: boolean;
  onGitHubExportClick: () => void;
  editorRef: RefObject<HTMLDivElement | null>;
}

export function EditorHeaderActions({
  modelConfigs,
  onRequestConfigs,
  loadingConfigs,
  onGitCloneClick,
  isGitHubExportReady,
  onGitHubExportClick,
  editorRef,
}: EditorHeaderActionsProps) {
  return (
    <BaseHeaderActions
      containerRef={editorRef}
      modelConfigs={modelConfigs}
      onRequestConfigs={onRequestConfigs}
      loadingConfigs={loadingConfigs}
      onGitCloneClick={onGitCloneClick}
      isGitHubExportReady={isGitHubExportReady}
      onGitHubExportClick={onGitHubExportClick}
    />
  );
}
